import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'

const ThumbPicture = ({ data }) => (
  <div className="content-thumbnail-picture">
    <a className="link" href={data.url} title={data.title}>
      <LazyLoad offset={200} once>
        <figure>
          <img
            src={data.background_image}
            alt={data.title}
            title={data.title}
            width="100%"
          />
        </figure>
      </LazyLoad>
    </a>
  </div>
)

ThumbPicture.propTypes = {
  data: PropTypes.shape({ ...ShapeThumb }).isRequired
}

export default ThumbPicture
